import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { listConversations } from '@/lib/api';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { MessageCircle } from 'lucide-react';

export default function MessagesPage() {
  const { user } = useAuth();
  const [convs, setConvs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await listConversations();
        setConvs(res.data || []);
      } finally { setLoading(false); }
    })();
  }, []);

  const isCompany = user?.user_type === 'company';

  return (
    <div className="min-h-screen bg-stone-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 py-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-full bronze-shine flex items-center justify-center text-white">
            <MessageCircle className="w-5 h-5" />
          </div>
          <div>
            <h1 className="text-2xl font-bold" data-testid="messages-page-title">Beskeder</h1>
            <p className="text-sm text-muted-foreground">
              {isCompany ? 'Chat med dine kunder om tilbudsanmodninger' : 'Chat med virksomheder om dine projekter'}
            </p>
          </div>
        </div>

        {loading ? (
          <div className="text-muted-foreground">Indlæser...</div>
        ) : convs.length === 0 ? (
          <Card>
            <CardContent className="py-12 text-center text-muted-foreground">
              {isCompany
                ? 'Ingen aktive chats endnu. Åbn en samtale fra dine tilbudsanmodninger.'
                : 'Ingen aktive chats endnu. En virksomhed kan oprette en chat med dig, når du har sendt en tilbudsanmodning.'}
            </CardContent>
          </Card>
        ) : (
          <div className="space-y-3">
            {convs.map((c) => (
              <Link key={c.id} to={`/chat/${c.id}`} className="block" data-testid={`messages-item-${c.id}`}>
                <Card className="hover:shadow-md transition-shadow">
                  <CardHeader className="pb-2">
                    <CardTitle className="text-base flex items-center justify-between">
                      <span className="truncate">{isCompany ? c.user_name : c.company_name}</span>
                      <span className="text-xs font-normal text-muted-foreground">
                        {new Date(c.last_message_at).toLocaleDateString('da-DK', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
                      </span>
                    </CardTitle>
                    <CardDescription className="line-clamp-1">{c.quote_description}</CardDescription>
                  </CardHeader>
                  {c.last_message_preview && (
                    <CardContent className="pt-0">
                      <p className="text-sm text-muted-foreground line-clamp-1">{c.last_message_preview}</p>
                    </CardContent>
                  )}
                </Card>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
